var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancleCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99984,
    cy: 9.99984,
    r: 8.33333,
    fill: "#CFD6D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0316 12.9697C12.2905 13.2286 12.7103 13.2286 12.9692 12.9697C13.2281 12.7108 13.2281 12.291 12.9692 12.0321L10.9381 10.001L12.9693 7.96982C13.2282 7.71091 13.2282 7.29113 12.9693 7.03222C12.7104 6.77331 12.2906 6.77331 12.0317 7.03222L10.0005 9.06342L7.9687 7.03159C7.70979 6.77267 7.29001 6.77267 7.0311 7.03159C6.77219 7.2905 6.77219 7.71027 7.0311 7.96919L9.06293 10.001L7.0312 12.0328C6.77229 12.2917 6.77229 12.7114 7.0312 12.9704C7.29011 13.2293 7.70989 13.2293 7.9688 12.9704L10.0005 10.9386L12.0316 12.9697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancleCircle);
export default __webpack_public_path__ + "static/media/icon-cancle-circle.39644858665828438f1fa783ac5b1dbc.svg";
export { ForwardRef as ReactComponent };